import { render, staticRenderFns } from "./ClinicianPatientInsurance.vue?vue&type=template&id=0a096b16"
import script from "./ClinicianPatientInsurance.vue?vue&type=script&lang=js"
export * from "./ClinicianPatientInsurance.vue?vue&type=script&lang=js"
import style1 from "./ClinicianPatientInsurance.vue?vue&type=style&index=1&id=0a096b16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports